import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import axiosInstance from '../../utils/axiosInstance';
import logoImageWithTitle from '../../assets/images/payPlus/payPlusWithTitle.png';

const NoAuthGuarantorKVKKApprove = () => {
    const toast = useRef(null);
    const { id: guarantorId } = useParams();
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [guarantorInfo, setGuarantorInfo] = useState(null);
    const [approved, setApproved] = useState(false);
    const [checked, setChecked] = useState(false);

    const fetchGuarantorInfo = async () => {
        try {
            setLoading(true);
            const response = await axiosInstance.get(`/api/v1/no-auth/get-guarantor/${guarantorId}`);
            setGuarantorInfo(response.data);

            // Check if KVKK is already approved
            if (response.data && response.data.kvkk && response.data.kvkk.id === 1) {
                setApproved(true);
            }
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Hata',
                detail: 'Kefil bilgileri yüklenirken bir hata oluştu.',
                life: 3000
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGuarantorInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guarantorId]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!checked) {
            toast.current.show({
                severity: 'warn',
                summary: 'Uyarı',
                detail: 'KVKK metnini onaylamanız gerekmektedir.',
                life: 3000
            });
            return;
        }

        try {
            setSubmitting(true);

            const response = await axiosInstance.put(`/api/v1/no-auth/guarantor-kvkk-approve/${guarantorId}`);
            setGuarantorInfo(response.data);
            setApproved(true);

            toast.current.show({
                severity: 'success',
                summary: 'Başarılı',
                detail: 'KVKK onayınız başarılı bir şekilde kaydedildi.',
                life: 3000
            });
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Hata',
                detail: 'KVKK onayı verilirken bir hata oluştu.',
                life: 3000
            });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <style>
                {`
                    * {
                        box-sizing: border-box;
                        max-width: 100%;
                    }
                    
                    html, body {
                        min-height: 100%;
                        margin: 0;
                        padding: 0;
                        overflow-x: hidden;
                        width: 100%;
                    }
                    
                    .kvkk-container {
                        min-height: 100vh;
                        background-color: #f8f9fa;
                        padding: 1rem;
                        background-image: url('${logoImageWithTitle}');
                        background-repeat: no-repeat;
                        background-position: center 95%;
                        background-size: 160px;
                        background-attachment: fixed;
                        background-blend-mode: lighten;
                        background-color: rgba(255, 255, 255, 0.95);
                    }
                    
                    .kvkk-card {
                        background-color: rgba(255, 255, 255, 0.9);
                        border-radius: 0.5rem;
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                        padding: 1rem;
                        margin-bottom: 1.5rem;
                        backdrop-filter: blur(5px);
                    }
                    
                    .kvkk-header {
                        border-bottom: 1px solid #e5e7eb;
                        padding-bottom: 1rem;
                        margin-bottom: 1.5rem;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                    
                    .kvkk-logo {
                        height: 50px;
                        margin-bottom: 1rem;
                    }
                    
                    .kvkk-title {
                        font-size: 1.3rem;
                        font-weight: 600;
                        color: #111827;
                        margin-bottom: 0.5rem;
                        text-align: center;
                    }
                    
                    .kvkk-subtitle {
                        font-size: 0.875rem;
                        color: #6b7280;
                        text-align: center;
                    }
                    
                    .kvkk-content {
                        margin-bottom: 1.5rem;
                    }
                    
                    .kvkk-text {
                        max-height: 300px;
                        overflow-y: auto;
                        background-color: #f3f4f6;
                        border-radius: 0.375rem;
                        padding: 1rem;
                        margin-bottom: 1rem;
                        font-size: 0.875rem;
                        color: #374151;
                        border-left: 4px solid #3b82f6;
                    }
                    
                    .kvkk-checkbox {
                        margin-bottom: 1.5rem;
                        display: flex;
                        align-items: center;
                    }
                    
                    .kvkk-checkbox-label {
                        margin-left: 0.5rem;
                        font-size: 0.9rem;
                        color: #4b5563;
                    }
                    
                    .guarantor-info {
                        background-color: #f3f4f6;
                        border-radius: 0.375rem;
                        padding: 1rem;
                        margin-bottom: 1.5rem;
                        border-left: 4px solid #3b82f6;
                    }
                    
                    .guarantor-info h3 {
                        font-size: 1rem;
                        margin: 0 0 0.5rem 0;
                        color: #1f2937;
                    }
                    
                    .guarantor-detail {
                        display: flex;
                        justify-content: space-between;
                        flex-wrap: wrap;
                        gap: 0.5rem;
                    }
                    
                    .detail-label {
                        font-size: 0.8rem;
                        color: #6b7280;
                        display: block;
                    }
                    
                    .detail-value {
                        font-size: 0.9rem;
                        font-weight: 500;
                        color: #111827;
                    }
                    
                    .kvkk-footer {
                        font-size: 0.875rem;
                        color: #6b7280;
                        text-align: center;
                        margin-top: 1.5rem;
                        padding-bottom: 80px;
                    }
                    
                    .approved-container {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        text-align: center;
                        padding: 2rem 1rem;
                    }
                    
                    .approved-icon {
                        color: #10b981;
                        font-size: 3rem;
                        margin-bottom: 1rem;
                    }
                    
                    .approved-title {
                        font-size: 1.25rem;
                        font-weight: 600;
                        color: #111827;
                        margin-bottom: 0.5rem;
                    }
                    
                    .approved-subtitle {
                        font-size: 0.875rem;
                        color: #6b7280;
                    }
                    
                    .loading-container {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        min-height: 200px;
                    }
                    
                    @media (min-width: 768px) {
                        .kvkk-container {
                            padding: 2rem;
                            background-position: 95% 95%;
                            background-size: 200px;
                        }
                        
                        .kvkk-card {
                            padding: 2rem;
                            max-width: 800px;
                            margin: 0 auto;
                        }
                        
                        .kvkk-title {
                            font-size: 1.75rem;
                        }
                        
                        .kvkk-header {
                            flex-direction: row;
                            justify-content: space-between;
                            align-items: center;
                        }
                        
                        .kvkk-logo {
                            margin-bottom: 0;
                            height: 70px;
                        }
                    }
                `}
            </style>

            <div className="kvkk-container">
                <Toast ref={toast} />

                <div className="kvkk-card">
                    <div className="kvkk-header">
                        <img src={logoImageWithTitle} alt="PayPlus Logo" className="kvkk-logo" />
                        <div>
                            <h1 className="kvkk-title">KVKK Onay Formu</h1>
                            {approved ? null : <p className="kvkk-subtitle">
                                Kişisel verilerin korunması kanunu kapsamında onay vermeniz gerekmektedir.
                            </p>}
                        </div>
                    </div>

                    {loading ? (
                        <div className="loading-container">
                            <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                            <p>Yükleniyor...</p>
                        </div>
                    ) : guarantorInfo ? (
                        approved ? (
                            <div className="approved-container">
                                <i className="pi pi-check-circle approved-icon"></i>
                                <h2 className="approved-title">KVKK Onayınız Alınmıştır !</h2>
                                <p className="approved-subtitle">
                                    KVKK kapsamında onayınız alınmıştır. Teşekkür ederiz.
                                </p>
                            </div>
                        ) : (
                            <>
                                <div className="guarantor-info">
                                    <h3 className='font-bold'>Kefil Bilgileri</h3>
                                    <div className="guarantor-detail">
                                        <div>
                                            <span className="detail-label">Ad Soyad:</span>
                                            <span className="detail-value">
                                                {guarantorInfo.name} {guarantorInfo.surname}
                                            </span>
                                        </div>
                                        <div>
                                            <span className="detail-label">T.C. Kimlik No:</span>
                                            <span className="detail-value">
                                                {guarantorInfo.identityNumber ?
                                                    guarantorInfo.identityNumber.substring(0, 3) + '*****' + guarantorInfo.identityNumber.substring(8) :
                                                    ''}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="kvkk-content">
                                    <div className="kvkk-text">
                                        <h1 className='font-bold'>KİŞİSEL VERİLERİN KORUNMASI KANUNU AYDINLATMA METNİ</h1>
                                        <p>
                                            6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, PayPlus olarak, Veri Sorumlusu sıfatıyla, siz değerli kefillerimizin kişisel verilerini aşağıda açıklanan amaçlar kapsamında hukuka ve dürüstlük kurallarına uygun bir şekilde işleyebilecek, kaydedebilecek, saklayabilecek, sınıflandırabilecek, güncelleyebilecek ve mevzuatın izin verdiği hallerde ve/veya işlendikleri amaçla sınırlı olarak 3. kişilere açıklayabilecek/aktarabilecektir.
                                        </p>
                                        <h4 className='font-bold'>1. KİŞİSEL VERİLERİN İŞLENME AMACI</h4>
                                        <p>
                                            Kişisel verileriniz;
                                            <ul>
                                                <li>Hizmetlerimizden faydalanabilmeniz için gerekli çalışmaların ilgili birimlerce yapılabilmesi,</li>
                                                <li>Size özel kampanya, avantaj ve hizmetlerin sunulması,</li>
                                                <li>Aldığınız/alacağınız ürün ve hizmete ilişkin iletişim kurulabilmesi,</li>
                                                <li>Ödeme işlemlerinizin gerçekleştirilmesi,</li>
                                                <li>İç işleyişin sağlanması ve geliştirilmesi,</li>
                                                <li>Hukuki süreçlerin yürütülmesi,</li>
                                                <li>Mevzuattan kaynaklanan yükümlülüklerimizin yerine getirilmesi,</li>
                                            </ul>
                                            amaçlarıyla KVKK'nın 5. ve 6. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları dahilinde işlenecektir.
                                        </p>
                                        <h4 className='font-bold'>2. KİŞİSEL VERİLERİN AKTARILMASI</h4>
                                        <p>
                                            Kişisel verileriniz; yukarıda belirtilen amaçlar doğrultusunda, KVKK'nın 8. ve 9. maddelerinde belirtilen şartlara uygun olarak, PayPlus tarafından hizmetin gerçekleştirilmesi için iş ortaklarımıza, tedarikçilerimize, kanunen yetkili kamu kurumlarına ve özel kişilere aktarılabilecektir.
                                        </p>
                                        <h4 className='font-bold'>3. KİŞİSEL VERİ TOPLAMANIN YÖNTEMİ VE HUKUKİ SEBEBİ</h4>
                                        <p>
                                            Kişisel verileriniz, her türlü sözlü, yazılı ya da elektronik ortamda, yukarıda yer verilen amaçlar doğrultusunda hizmetlerimizin sunulabilmesi ve bu kapsamda PayPlus'ın sözleşme ve yasadan doğan mesuliyetlerini eksiksiz ve doğru bir şekilde yerine getirebilmesi için toplanır.
                                        </p>
                                        <h4 className='font-bold'>4. KİŞİSEL VERİ SAHİBİNİN HAKLARI</h4>
                                        <p>
                                            KVKK'nın 11. maddesi uyarınca herkes, veri sorumlusuna başvurarak kendisiyle ilgili;
                                            <ul>
                                                <li>Kişisel veri işlenip işlenmediğini öğrenme,</li>
                                                <li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,</li>
                                                <li>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
                                                <li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme,</li>
                                                <li>Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme,</li>
                                                <li>Kişisel verilerin silinmesini veya yok edilmesini isteme,</li>
                                                <li>Kişisel verilerin düzeltilmesi, silinmesi ya da yok edilmesi halinde bu işlemlerin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
                                                <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme,</li>
                                                <li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme haklarına sahiptir.</li>
                                            </ul>
                                        </p>
                                    </div>

                                    <form onSubmit={handleSubmit}>
                                        <div className="kvkk-checkbox">
                                            <Checkbox
                                                inputId="kvkk"
                                                checked={checked}
                                                onChange={e => setChecked(e.checked)}
                                            />
                                            <label htmlFor="kvkk" className="kvkk-checkbox-label">
                                                Kişisel Verilerin Korunması Kanunu kapsamındaki aydınlatma metnini okudum ve anladım. Kişisel verilerimin işlenmesine onay veriyorum.
                                            </label>
                                        </div>

                                        <Button
                                            type="submit"
                                            label="Onaylıyorum"
                                            className="bg-green-500 border border-green-500 hover:bg-green-700 hover:border-green-700 rounded-lg text-white py-5 shadow-lg"
                                            style={{ width: '100%' }}
                                            disabled={!checked || submitting}
                                            loading={submitting}
                                        />
                                    </form>
                                </div>
                            </>
                        )
                    ) : (
                        <div className="approved-container">
                            <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem', color: '#f59e0b' }}></i>
                            <h2 className="approved-title">Kefil Bilgisi Bulunamadı</h2>
                            <p className="approved-subtitle">
                                Geçersiz veya süresi dolmuş bir bağlantı kullanıyor olabilirsiniz.
                            </p>
                        </div>
                    )}
                </div>

                <div className="kvkk-footer">
                    <p>© {new Date().getFullYear()} PayPlus. Tüm hakları saklıdır.</p>
                </div>
            </div>
        </>
    );
};

export default NoAuthGuarantorKVKKApprove;